<template>
  <div class="copy-cell-wrapper">
    <div class="copy-cell-title flex">
      <div class="list-left">
        <UserAvatar :src="initAvatarUrl" />
      </div>
      <div class="list-right relative">
        <div class="content-top flex justify-c_space-b">
          <p class="user-wrapper">
            <span class="name text-ellipsis">{{ initApplicantName }}</span>
            <span class="male" v-if="initApplicantSex">
              <i class="el-icon-male"></i>
            </span>
            <span class="female" v-else>
              <i class="el-icon-female"></i>
            </span>
          </p>
          <span class="time">{{ initDate }}</span>
        </div>
        <div class="copy-content-bottom flex">
          <p class="lastmsg">{{ initApplyText }}</p>
          <p class="respond-menu" v-if="apply.state == 0">
            <span class="agree" @click="agreeConfirm">同意</span>
            <span class="decline" @click="declineApply">拒绝</span>
          </p>
          <p class="respond-menu" v-if="apply.state == 1">
            <span class="agree" @click="initCopyTree">开始复制</span>
            <span class="decline" @click="deleteAgree">删除</span>
          </p>
        </div>
      </div>
    </div>
    <div class="handlian-apply-wrapper" v-if="apply.state == 1">
      <el-dialog
        :title="treeTitle"
        :visible.sync="copyVisible"
        width="872px"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :before-close="clearApplyForm"
        custom-class="handlian-copy-tree"
      >
        <div>
          <div class="copy-tree-wrapper" v-loading="loadTree">
            <div :id="treeContainerId" class="copy-tree-container">
              <!-- <canvas id="canvasForClanTree"></canvas> -->
            </div>
          </div>
          <div class="copy-form-wrap">
            <el-form
              :model="copyRelationForm"
              :rules="relationRules"
              ref="copyRelationForm"
              :inline="true"
              class="copy-tree-form"
            >
              <el-form-item prop="husband" :label="initWaitName">
                <el-select
                  v-model="copyRelationForm.husband"
                  @change="selectHusbandChange"
                  placeholder="— 父亲 —"
                >
                  <el-option
                    v-for="(item, index) in ancestorMember"
                    :key="index"
                    :label="item.userName"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="wife">
                <el-select
                  v-model="copyRelationForm.wife"
                  placeholder="— 母亲 —"
                >
                  <el-option
                    v-for="(item, index) in mateList"
                    :key="index"
                    :label="item.userName"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="handlian-btn add-member-button"
                  type="primary"
                  @click="submitAddForm('copyRelationForm')"
                  >确定</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getFullDate } from "../utils/date";
import { apiMap } from "../utils/apiMap";
import UserAvatar from "./UserAvatar";
import dTree from "../utils/dTree";
import { birthToDate, formatDeadKey } from "../utils/feed";
import $ from "jquery";
import _ from "lodash";
import qs from "qs";
export default {
  name: "copy-tree-apply",
  props: {
    apply: Object,
  },
  data() {
    var validateHusband = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请选择父亲"));
      } else {
        callback();
      }
    };
    var validateWife = (rule, value, callback) => {
      if (value == "") {
        if (this.mateList.length != 0) {
          callback(new Error("请选择母亲"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      copyVisible: false,
      copyRelationForm: {
        husband: "",
        wife: "",
      },
      relationRules: {
        husband: [{ validator: validateHusband, trigger: "change" }],
        wife: [{ validator: validateWife, trigger: "change" }],
      },
      loadTree: true,
      boxWidth: 80,
      boxHeight: 30,
      fatherDivPad: 30,
      fatherDivWidth: 832,
      fatherDivHeight: 92,
      motherDivWidth: 832,
      motherDivHeight: 92,
      boxMargin: 11,
      mateScale: 15,
      husbandScale: 2,
      parentPosition: {},
      treeData: {},
      fatherID: "",
      stopNode: "",
      treeTitle: "复制家谱",
      ancestorMember: [],
      ancestorMate: {},
      mateList: [],
      waitName: "你祖先",
      newLiveUser: [],
      personMap: {},
      treeContainerId: `clanTree-${this.apply.id}`,
    };
  },
  components: {
    UserAvatar,
  },
  computed: {
    initAvatarUrl() {
      if (this.apply.hasOwnProperty("fromUserInfo")) {
        return this.apply.fromUserInfo.headImgUrl;
      } else if (this.apply.hasOwnProperty("toUserInfo")) {
        return this.apply.toUserInfo.headImgUrl;
      }
    },
    initDate() {
      return getFullDate(new Date(this.apply.created_at * 1000));
    },
    initApplyText() {
      if (this.apply.hasOwnProperty("fromUserInfo")) {
        return "对方申请复制你的家谱";
      } else if (this.apply.hasOwnProperty("toUserInfo")) {
        return "对方同意了你复制家谱的申请";
      }
    },
    initApplicantName() {
      if (this.apply.hasOwnProperty("fromUserInfo")) {
        return this.apply.fromUserInfo.realName || this.apply.fromUserInfo.name;
      } else if (this.apply.hasOwnProperty("toUserInfo")) {
        return this.apply.toUserInfo.realName || this.apply.toUserInfo.name;
      }
    },
    initApplicantSex() {
      if (this.apply.hasOwnProperty("fromUserInfo")) {
        return this.apply.fromUserInfo.sex == 1;
      } else if (this.apply.hasOwnProperty("toUserInfo")) {
        return this.apply.toUserInfo.sex == 1;
      }
    },
    initWaitName() {
      return `请选择 ${this.waitName} 的父（母）`;
    },
  },
  methods: {
    beArray(arr) {
      return arr instanceof Array;
    },
    agreeConfirm() {
      if (this.apply.hasOwnProperty("fromUserInfo")) {
        var tipMsg = `${this.apply.fromUserInfo.realName} 申请复制你的家谱，确定后授权成功。`;
        this.$confirm(tipMsg, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          showClose: false,
        })
          .then(() => {
            this.handleCopyApply(1);
          })
          .catch(() => {});
      }
    },
    declineApply() {
      this.$confirm("确定拒绝这条复制家谱申请吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showClose: false,
      })
        .then(() => {
          this.handleCopyApply(2);
        })
        .catch(() => {});
    },
    initCopyTree() {
      let _this = this;
      _this.getMyTree(function(response) {
        switch (response.code) {
          case 0:
            _this.getMyProfile(function(res) {
              if (res["isValiated"] == 1) {
                _this.copyVisible = true;
                _this.getFamilyTree();
                _this.waitName = res.realName;
              } else {
                _this.$alert("你未在传联APP进行实名认证，暂不能复制家谱", {
                  confirmButtonText: "确定",
                  showClose: false,
                });
              }
            });
            break;
          case 1:
            _this.copyVisible = true;
            _this.getFamilyTree();
            _this.waitName = response.userName;
            break;
          case 2:
            _this.$alert(
              "为了使家谱信息准确无误，至少完善自己的父亲节点，才可以复制家谱。",
              {
                confirmButtonText: "确定",
                showClose: false,
              }
            );
            break;
          case 3:
            _this.$alert("请完善你家谱中最顶上男性的资料，再申请复制", {
              confirmButtonText: "确定",
              showClose: false,
            });
            break;
          case 4:
            var errInfo = `系统显示，${response.userName} 健在，为减少错误概率，他才有权复制家谱！`;
            _this.$alert(errInfo, {
              confirmButtonText: "确定",
              showClose: false,
            });
            break;
        }
      });
    },
    handleCopyApply(action) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["handleCopyApply"]["method"],
          url: apiMap["handleCopyApply"]["url"],
          data: `token=${loginUser.token}&action=${action}&id=${_this.apply.id}`,
        })
        .then(function(response) {
          // console.log(response.data.result.data)
          if (response.data.result.statusCode == 1) {
            _this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              offset: 50,
            });
            _this.$store.dispatch("deleteCopyTreeApply", _this.apply.id);
          } else {
            _this.$message({
              message: "操作失败，稍后再试",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deleteAgree() {
      let _this = this;
      if (_this.apply.hasOwnProperty("id")) {
        var tipMsg = "确定删除这条消息吗？";
        _this
          .$confirm(tipMsg, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            customClass: "cl-edit-profile",
            showClose: false,
          })
          .then(() => {
            let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
            _this
              .$axios({
                baseURL: apiMap["commonUrl"],
                method: apiMap["removeApply"]["method"],
                url: apiMap["removeApply"]["url"],
                data: `token=${loginUser.token}&id=${_this.apply.id}`,
              })
              .then(function(response) {
                // console.log(response.data.result.data)
                if (response.data.result.statusCode == 1) {
                  _this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  _this.$store.dispatch("deleteCopyTreeApply", _this.apply.id);
                } else {
                  _this.$message({
                    message: "操作失败，稍后再试",
                  });
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          })
          .catch(() => {});
      }
    },
    getMyTree(okCBK) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["fatherTree"]["method"],
          url: apiMap["fatherTree"]["url"],
          params: {
            token: loginUser.token,
          },
        })
        .then(function(response) {
          var res = {};
          res.code = response.data.result.statusCode;
          if (response.data.result.statusCode == 1) {
            // let ancestorID = response.data.result.data.userId;
            // let curUserID = loginUser.userId.toString();
            res.userName = response.data.result.data.userName;
            // if (ancestorID != curUserID) {
            //   //活人不能复制
            //   if (response.data.result.data.status == 0) {
            //     res.code = 4;
            //   } else if (response.data.result.data.status == 1) {
            //     res.code = 3;
            //   }
            // } else {
            //   res.code = 2;
            // }
            if (response.data.result.data.status == 1) {
              //临时节点不能复制
              res.code = 3;
            }
          }
          okCBK(res);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    clearApplyForm() {
      this.copyVisible = false;
      this.waitName = "你祖先";
      this.copyRelationForm = { husband: "", wife: "" };
      this.ancestorMember = [];
      this.mateList = [];
    },
    submitAddForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(_this.$refs[formName].model)
          let husbandID = _this.$refs[formName].model.husband;
          let wifeID = _this.$refs[formName].model.wife;
          let husbandInfo = _this.ancestorMember.filter(
            (item) => item.userId == husbandID
          );
          let wifeInfo = _this.mateList.filter((item) => item.userId == wifeID);
          var tipMsg = `为了保证家谱信息正确，请再核对`;
          if (husbandInfo.length != 0) {
            if (wifeInfo.length != 0) {
              tipMsg = `为了保证家谱信息正确，请再核对：\n ${husbandInfo[0]["userName"]} 、${wifeInfo[0]["userName"]} 是 ${_this.waitName} 的父母`;
            } else {
              tipMsg = `为了保证家谱信息正确，请再核对：\n ${husbandInfo[0]["userName"]} 是 ${_this.waitName} 的父亲`;
            }
          } else {
            return false;
          }
          _this
            .$confirm(tipMsg, {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              closeOnClickModal: false,
              customClass: "cl-copy-confirm",
              showClose: false,
            })
            .then(() => {
              // console.log(husbandID);
              // console.log(wifeID)
              let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
              var submitData = {
                token: loginUser.token,
                toUserId: _this.apply.toUserId,
                fatherNodeId: husbandID,
              };
              if (wifeID != "") {
                submitData.motherNodeId = wifeID;
              } else {
                submitData.motherNodeId = 0;
              }
              _this.copyFriendTree(qs.stringify(submitData, { encode: false }));
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    getFamilyTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["fatherTree"]["method"],
          url: apiMap["fatherTree"]["url"],
          params: {
            token: loginUser.token,
            userId: _this.apply.toUserId,
            family: 1,
          },
        })
        .then(function(response) {
          _this.treeTitle = `复制 ${_this.apply.toUserInfo.realName} 的家谱`;
          if (response.data.result.statusCode == 1) {
            _this.treeData = response.data.result.data;
            _this.loadTree = false;
            _this.fatherID = response.data.result.currentUserParent.fatherNode;
            _this.stopNode = _this.apply.toUserId;
            _this.initTreeData(_this.treeData, 1);
            _this.initTreeWithD3(_this.treeData);
            // _this.analysisFatherTree(_this.treeData,1);
            // setTimeout(()=>{
            //     _this.drawFatherLine();
            //     _this.initTreeMemberClick();
            // },10)
          } else {
            _this.$message("获取家谱失败，稍后再试");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    analysisFatherTree(data, generation) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var ancestorDom = document.getElementsByClassName("generation_1")[0];
      var userName = "";
      if (data.userName) {
        userName = data.userName == "null" ? "?" : data.userName;
      } else {
        userName = "?";
      }
      if (data.sex == "1" && data.status != 1) {
        var userItem = {
          userId: data.userId,
          userName: userName,
          generation: generation,
        };
        _this.ancestorMember.push(userItem);
      }
      if (!ancestorDom) {
        var ancestorProfile = [];
        ancestorProfile[0] = $('<a class="child">' + userName + "</a>");
        ancestorProfile[0].attr({
          id: data.userId,
          sex: data.sex,
          status: data.status,
          birthday: data.birthday,
          title: userName == "?" ? "" : userName,
          "data-copy": data.copyFlag,
        });
        var newNode = $("<div>").attr({
          class: "child-box generation_1",
          generation: "1",
        });
        $(newNode)
          .append(ancestorProfile)
          .appendTo($("#clanTree"));
      }
      var userSpouse = [];
      for (var p = 0; p < data.partners.length; p++) {
        var spouseName = "";
        if (data.partners[p].userName) {
          spouseName =
            data.partners[p].userName == "null"
              ? "?"
              : data.partners[p].userName;
        } else {
          spouseName = "?";
        }
        var spouseId = data.partners[p].userId;
        var status = data.partners[p].status;

        var curMate = {
          userId: data.partners[p].userId,
          userName: spouseName,
        };
        userSpouse.push(curMate);
        var spouseClass = `spouse ${data.userId}`;
        if (
          data.partnerPublicChildren[p] &&
          data.partnerPublicChildren[p].length > 0
        ) {
          spouseClass = `spouse hasChild ${data.userId}`;
        }
        var sureSpouse = $(
          '<a class="' + spouseClass + '">' + spouseName + "</a>"
        );
        sureSpouse.attr({
          id: spouseId,
          sex: data.partners[p].sex,
          mate: data.userId,
          status: status,
          title: spouseName == "?" ? "" : spouseName,
        });
        _this.createOneGeneContainer(sureSpouse, generation);
      }
      if (data.sex == "1") {
        _this.ancestorMate[data.userId] = userSpouse;
      }
      if (data.userId == _this.fatherID) {
        //父辈以下不展示
        return false;
      }
      generation++;
      if (data.partnerPublicChildren.length !== 0) {
        for (var i = 0; i < data.partnerPublicChildren.length; i++) {
          var sureChildMother = data.partners[i].userId;
          var orderedChildren = _this.descSortChildrenInAll(
            data.partnerPublicChildren[i]
          );
          for (var j = 0; j < orderedChildren.length; j++) {
            if (orderedChildren[j]) {
              var sureChildName = "";
              if (orderedChildren[j] && orderedChildren[j].userName) {
                sureChildName =
                  orderedChildren[j].userName == "null"
                    ? "?"
                    : orderedChildren[j].userName;
              } else {
                sureChildName = "?";
              }
              var sureChild = $(
                '<a class="child ' +
                  sureChildMother +
                  '">' +
                  sureChildName +
                  "</a>"
              );
              sureChild.attr({
                id: orderedChildren[j].userId,
                father: data.userId,
                mother: sureChildMother,
                sex: orderedChildren[j].sex,
                status: orderedChildren[j].status,
                birthday: orderedChildren[j].birthday,
                title: sureChildName == "?" ? "" : sureChildName,
                "data-copy": orderedChildren[j].copyFlag,
              });
              _this.createOneGeneContainer(sureChild, generation);
              _this.analysisFatherTree(orderedChildren[j], generation);
            }
          }
        }
      }
      _this.arrangeAllChild();
    },
    arrangeAllChild() {
      var divBinJQ = $("#clanTree");
      var divJQ = $(">div.child-box", divBinJQ);
      var EntityList = [];
      divJQ.each(function() {
        var thisJQ = $(this);
        EntityList.push({
          generation: parseInt(thisJQ.attr("generation"), 10),
          JQ: thisJQ,
        });
      });
      EntityList.sort(function(a, b) {
        return a.generation - b.generation;
      });
      for (var i = 0; i < EntityList.length; i++) {
        EntityList[i].JQ.appendTo(divBinJQ);
      }
    },
    createOneGeneContainer(node, generation) {
      var nodeContainer = document.getElementsByClassName(
        "generation_" + generation
      )[0];
      if (nodeContainer) {
        $(nodeContainer)
          .append(node)
          .appendTo($("#clanTree"));
      } else {
        var newContainer = $("<div>").attr({
          class: "child-box generation_" + generation,
          generation: generation,
        });
        $(newContainer)
          .append(node)
          .appendTo($("#clanTree"));
      }
    },
    //兄弟排序
    descSortChildrenInAll(jsonObj) {
      var newArray = new Array();
      var tempJson = {};
      if (jsonObj.length > 1) {
        var birthArr = new Array();
        var birthIdArr = [];
        var nonBirthPerson = [];
        // var regExp = /^[0-9.-]+$/;
        var regExp = /^[\-|0-9][0-9]*/;
        for (let i = 0; i < jsonObj.length; i++) {
          //将有生日的节点的生日和ID保存在生日数组中
          if (regExp.test(jsonObj[i].birthday) && jsonObj[i].birthday != "0") {
            var birthKey = "";
            if (jsonObj[i].status == 0) {
              birthKey = birthToDate(jsonObj[i].birthday);
            } else if (jsonObj[i].status == 2) {
              birthKey = formatDeadKey(jsonObj[i].birthday);
            }
            birthArr.push({
              birthday: birthKey,
              userId: jsonObj[i].userId,
            });
          } else {
            nonBirthPerson.push(jsonObj[i]);
          }
          var userId = jsonObj[i].userId;

          //将所有节点放在临时对象中
          tempJson[userId] = {
            userId: jsonObj[i].userId,
            sex: jsonObj[i].sex,
            addTime: jsonObj[i].addTime,
            userName: jsonObj[i].userName,
            birthday: jsonObj[i].birthday,
            partnerPublicChildren: jsonObj[i].partnerPublicChildren,
            partners: jsonObj[i].partners,
            status: jsonObj[i].status,
          };
        }

        //对有生日的节点排序，取得对应的ID
        if (birthArr.length > 0) {
          var sortBirth = _.sortBy(birthArr, ["birthday"]);
          birthIdArr = Array.from(sortBirth.map((d) => d["userId"]));
        }

        if (birthIdArr.length > 0) {
          for (let x = 0; x < birthIdArr.length; x++) {
            var mixtureKey = birthIdArr[x];
            if (tempJson[mixtureKey]) {
              newArray[x] = tempJson[mixtureKey];
            }
          }
        }

        if (nonBirthPerson.length != 0) {
          for (let m = 0; m < nonBirthPerson.length; m++) {
            var findArr = newArray.filter(
              (item) => item.userId === nonBirthPerson[m].userId
            );
            if (findArr.length == 0) {
              newArray.push(nonBirthPerson[m]);
            }
          }
        }
      } else {
        newArray = jsonObj;
      }
      return newArray;
    },
    //初始化画布
    initCanvasContext() {
      let _this = this;
      var generationPerson = new Array();
      $("#clanTree")
        .find(".child-box")
        .each(function() {
          var oneGeneration = $(this).find("a").length;
          generationPerson.push(oneGeneration);

          // $(this).find("a").css("margin",10+oneGeneration*2)
        });

      // var maxUser = sortArray(generationPerson,"max");
      // var maxGeneration = sortArray(generationArr,"max");
      // _.sortedUniq([1, 1, 2]);
      generationPerson = Array.from(new Set(generationPerson));
      generationPerson.sort(function(a, b) {
        return a - b;
      });
      var maxUser = generationPerson.pop();
      var maxGeneration = $("#clanTree").find(".child-box").length;
      var canvas = document.getElementById("canvasForClanTree");
      var ctx = canvas.getContext("2d");
      var basicWidth = _this.boxWidth + 2 * _this.boxMargin + 2;
      canvas.width = 832;
      if (maxUser * basicWidth > 832) {
        _this.fatherDivWidth = maxUser * basicWidth;
        $("#clanTree")
          .find(".child-box")
          .css("width", _this.fatherDivWidth + "px");
        canvas.width = _this.fatherDivWidth;
      }
      canvas.height = maxGeneration * _this.fatherDivHeight;
      return ctx;
    },
    drawFatherLine() {
      let _this = this;
      var ctx = _this.initCanvasContext();
      ctx.strokeStyle = "#000000";
      $(".child-box")
        .find(".child")
        .each(function() {
          //var Mother = this.classList[1];
          var main = $(this);
          // var sex = main.attr("sex");
          var key = main.attr("id");
          var motherId = main.attr("mother");

          var positionWithMon = "";
          if (motherId) {
            if (main[0].offsetLeft - $("#" + motherId)[0].offsetLeft < 0) {
              positionWithMon = "left";
            } else {
              positionWithMon = "right";
            }
          }
          var generation = parseInt(
            $(this)
              .parent()
              .attr("generation")
          );

          var brotherNodes = main.parents(".generation_" + generation).find("a")
            .length;

          var prevNodes = main.prevAll("a").length;
          var Partners = main
            .parent()
            .find(".spouse")
            .filter("." + key);
          var sumMargin =
            [brotherNodes - (2 * prevNodes + 1)] * _this.boxMargin; //总间距
          var sumWidth =
            ([brotherNodes - (2 * prevNodes + 2)] / 2) * _this.boxWidth; //总宽度

          var mainAbscissa = _this.fatherDivWidth / 2 - sumMargin - sumWidth; //配偶横坐标
          var mainOrdinate = (generation - 0.5) * _this.fatherDivHeight; //配偶纵坐标
          // 配偶基准坐标
          var matePosition = {
            x: mainAbscissa + _this.boxMargin,
            y: mainOrdinate,
          };
          var hasChildSpouse = main.parent().find(".hasChild");
          for (var s = 0; s < Partners.length; s++) {
            var curPartnerPrevNodes = $(Partners[s]).prevAll("a").length;
            //var husbandId = $(Partners[s]).attr("mate");
            var mateId = $(Partners[s]).attr("id");
            var Children = $(Partners[s])
              .parent()
              .next("div")
              .find(".child")
              .filter("." + mateId);
            //console.log($(Children[0]));  //可判断相对位置
            var curPartnerMargin =
              [brotherNodes - (2 * curPartnerPrevNodes + 1)] * _this.boxMargin; //总间距
            var curPartnerWidth =
              ([brotherNodes - (2 * curPartnerPrevNodes + 2)] / 2) *
              _this.boxWidth; //总宽度
            var curPartnerAbscissa =
              _this.fatherDivWidth / 2 -
              curPartnerMargin -
              curPartnerWidth -
              _this.boxWidth; //第s任妻子横坐标
            var childPosition = "";
            // var nextNodes = 0;
            // var childPrevNodes = 0;
            var matePrevNodes = 0;
            var mateNextNodes = 0;
            var mateIndex = 0;
            if (Children[0]) {
              // console.log(main.text());
              // console.log($(Partners[s])[0].offsetLeft);
              // console.log($(Children[0])[0].offsetLeft);
              if (
                $(Children[0])[0].offsetLeft - $(Partners[s])[0].offsetLeft <
                0
              ) {
                childPosition = "left";
              } else {
                childPosition = "right";
              }
              matePrevNodes = $(Partners[s]).prevAll("a").length;
              mateNextNodes = $(Partners[s]).nextAll("a").length;
              for (let i = 0; i < hasChildSpouse.length; i++) {
                if ($(hasChildSpouse[i]).attr("id") == mateId) {
                  mateIndex = i + 1;
                }
              }
              // nextNodes = $(Children[0]).nextAll("a").length;
              // childPrevNodes = $(Children[0]).prevAll("a").length;
            }
            var curPartnerOrdinate = (generation - 0.5) * _this.fatherDivHeight; //第s任妻子纵坐标
            var parentPositionY = 0;
            if (hasChildSpouse.length > 1) {
              if (childPosition == "left") {
                parentPositionY =
                  20 +
                  2 * mateIndex +
                  2 * matePrevNodes +
                  hasChildSpouse.length;
              } else if (childPosition == "right") {
                parentPositionY =
                  20 +
                  2 * mateIndex -
                  2 * mateNextNodes -
                  hasChildSpouse.length;
              }
            } else {
              parentPositionY =
                _this.motherDivHeight / 2 - prevNodes * _this.husbandScale;
            }

            if (parentPositionY < 19) {
              if (childPosition == "left") {
                parentPositionY =
                  20 +
                  2 * mateIndex +
                  2 * matePrevNodes +
                  hasChildSpouse.length;
              } else if (childPosition == "right") {
                parentPositionY =
                  20 +
                  3 * mateIndex +
                  2 * mateNextNodes +
                  hasChildSpouse.length -
                  matePrevNodes;
              }
            }
            if (parentPositionY > 55) {
              parentPositionY = 55;
            }
            _this.parentPosition[mateId] = {
              x: curPartnerAbscissa - _this.boxMargin,
              y: curPartnerOrdinate + parentPositionY,
            };

            // 配偶基准坐标
            var curPartnerPosition = {
              x: curPartnerAbscissa - _this.boxMargin,
              y: curPartnerOrdinate,
            };

            //第s任配偶连接配偶横线
            ctx.beginPath();
            ctx.moveTo(curPartnerAbscissa, curPartnerOrdinate);
            ctx.lineTo(curPartnerPosition.x, curPartnerPosition.y);
            ctx.stroke();
            ctx.closePath();

            if (Children.length != 0) {
              //第s任配偶连接子代竖线
              ctx.beginPath();
              ctx.moveTo(curPartnerPosition.x, curPartnerPosition.y);
              ctx.lineTo(
                curPartnerPosition.x,
                curPartnerOrdinate + parentPositionY
              );
              ctx.stroke();
              ctx.closePath();
            }

            //配偶数大于1
            if (s != 0) {
              //配偶向上竖线(第一任妻子)
              if (Children[1]) {
                ctx.beginPath();
                ctx.moveTo(matePosition.x - 5, matePosition.y);
                ctx.lineTo(
                  matePosition.x - 5,
                  matePosition.y - _this.boxHeight
                );
                ctx.stroke();
                ctx.closePath();
              } else {
                ctx.beginPath();
                ctx.moveTo(matePosition.x, matePosition.y);
                ctx.lineTo(matePosition.x, matePosition.y - _this.boxHeight);
                ctx.stroke();
                ctx.closePath();
              }

              //配偶向上竖线(非第一任妻子)
              ctx.beginPath();
              ctx.moveTo(curPartnerPosition.x, curPartnerPosition.y);
              ctx.lineTo(
                curPartnerPosition.x,
                curPartnerPosition.y - _this.boxHeight
              );
              ctx.stroke();
              ctx.closePath();

              //配偶连接配偶横线
              ctx.beginPath();
              ctx.moveTo(matePosition.x, matePosition.y - _this.boxHeight);
              ctx.lineTo(
                curPartnerPosition.x,
                curPartnerPosition.y - _this.boxHeight
              );
              ctx.stroke();
              ctx.closePath();
            }
          }

          if (Partners.length != 0) {
            //配偶横线
            var curPartnerX = mainAbscissa;
            ctx.beginPath();
            ctx.moveTo(curPartnerX, mainOrdinate);
            ctx.lineTo(matePosition.x, matePosition.y);
            ctx.stroke();
            ctx.closePath();
          }

          var aimPosition = _this.parentPosition[motherId];

          if (aimPosition) {
            var childBasicX = mainAbscissa - _this.boxWidth / 2;
            if (positionWithMon == "left") {
              childBasicX = childBasicX + 5;
            } else if (positionWithMon == "right") {
              childBasicX = childBasicX - 5;
            }

            var childBasicPosition = {
              x: childBasicX,
              y: mainOrdinate - _this.boxHeight / 2,
            };

            var difference = childBasicPosition.y - aimPosition.y;
            if (difference != _this.fatherDivPad) {
              var supplement = difference - _this.fatherDivPad;
              //子代向上竖线 (同父异母)
              ctx.beginPath();
              ctx.moveTo(
                childBasicPosition.x,
                childBasicPosition.y - _this.fatherDivHeight / 3 - supplement
              );
              ctx.lineTo(childBasicPosition.x, childBasicPosition.y);
              ctx.stroke();
              ctx.closePath();

              //子代与父母横线
              ctx.beginPath();
              ctx.moveTo(
                childBasicPosition.x,
                childBasicPosition.y - _this.fatherDivHeight / 3 - supplement
              );
              ctx.lineTo(aimPosition.x, aimPosition.y);
              ctx.stroke();
              ctx.closePath();
            } else {
              //子代向上竖线 (同父同母)
              ctx.beginPath();
              ctx.moveTo(
                childBasicPosition.x,
                childBasicPosition.y - _this.fatherDivHeight / 3
              );
              ctx.lineTo(childBasicPosition.x, childBasicPosition.y);
              ctx.stroke();
              ctx.closePath();

              //子代与父母横线
              ctx.beginPath();
              ctx.moveTo(
                childBasicPosition.x,
                childBasicPosition.y - _this.fatherDivHeight / 3
              );
              ctx.lineTo(aimPosition.x, aimPosition.y);
              ctx.stroke();
              ctx.closePath();
            }
          }
        });
    },
    selectHusbandChange(userID) {
      this.copyRelationForm.wife = "";
      this.mateList = [];
      let mates = this.ancestorMate[userID];
      if (mates) {
        this.mateList = mates;
        if (mates.length == 1) {
          this.copyRelationForm.wife = mates[0].userId;
        }
      }
    },
    initTreeMemberClick() {
      let _this = this;
      $("#clanTree").on("click", "a", function() {
        var userId = $(this).attr("id");
        var sex = $(this).attr("sex");
        var status = $(this).attr("status");
        if (sex == "1") {
          if (status != "1") {
            _this.copyRelationForm.husband = userId;
            _this.selectHusbandChange(userId);
          } else {
            _this.$message({
              message: "这个亲人资料没有完善，不能选择噢",
            });
          }
        } else {
          _this.$message({
            message: "请选择男性家谱成员",
          });
        }
      });
    },
    copyFriendTree(params) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["copyTree"]["method"],
          url: apiMap["copyTree"]["url"],
          data: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.$alert("复制家谱成功！", {
              confirmButtonText: "确定",
              showClose: false,
            });
            _this.clearApplyForm();
            _this.reloadMyTree();
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        });
    },
    reloadMyTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["fatherTree"]["method"],
          url: apiMap["fatherTree"]["url"],
          params: {
            token: loginUser.token,
            family: 1,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.initMyTree(response.data.result.data, 1);
            setTimeout(() => {
              _this.preCopySuccessMsg();
            }, 2000);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initMyTree(data, generation) {
      let _this = this;
      //没有被发讣告的用户
      if (data["deathFlag"] != 1 && data["status"] == 0) {
        if (!_this.newLiveUser.includes(data.userId)) {
          _this.newLiveUser.push(data.userId);
        }
      }
      let partner = data.partners;
      // 过滤家谱成员配偶 08-17
      // if (_this.beArray(partner)) {
      //     for(let p in partner){
      //         if (partner[p].hasOwnProperty('status')) {
      //             if (partner[p]['deathFlag']!=1 && partner[p]['status']==0) {
      //                 if (!_this.newLiveUser.includes(partner[p].userId)) {
      //                     _this.newLiveUser.push(partner[p].userId);
      //                 }
      //             }
      //         }
      //     }
      // }
      generation++;
      let Children = data.partnerPublicChildren;
      if (_this.beArray(Children)) {
        for (let i in Children) {
          for (let j in Children[i]) {
            if (Children[i][j].hasOwnProperty("status")) {
              if (
                Children[i][j]["deathFlag"] != 1 &&
                Children[i][j]["status"] == 0
              ) {
                if (!_this.newLiveUser.includes(Children[i][j].userId)) {
                  _this.newLiveUser.push(Children[i][j].userId);
                }
              }
            }
            _this.initMyTree(Children[i][j], generation);
          }
        }
      }
    },
    //发送复制家谱通知
    preCopySuccessMsg() {
      if (this.newLiveUser.length > 0) {
        let _this = this;
        let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
        var msgContent = `${loginUser.realName}（申请人）已经成功复制 ${_this.apply.toUserInfo.realName}（同意人）的家谱，族谱已经有变化，前去查看吧！`;
        var initData = {
          fromId: "admin",
          toArr: _this.newLiveUser,
          msgType: "504",
          msgDesc: "您有一条新消息",
          msgContent: msgContent,
        };
        var requestJson =
          "{\n" +
          '    "SyncOtherMachine": 1, \n' +
          '    "From_Account": "' +
          initData["fromId"] +
          '",\n' +
          '    "To_Account": [\n' +
          '        "' +
          initData["toArr"].join('","') +
          '"\n' +
          "    ],\n" +
          '    "MsgRandom": 19901224,\n' +
          '    "MsgBody": [\n' +
          "        {\n" +
          '            "MsgType": "TIMCustomElem",\n' +
          '             "MsgContent": {\n' +
          '        \t"Data": "' +
          initData["msgType"] +
          '", \n' +
          '        \t"Desc": "' +
          initData["msgDesc"] +
          '", \n' +
          '        \t"Ext": "' +
          initData["msgContent"] +
          '"\n' +
          "   \t }\n" +
          "        }\n" +
          "    ],\n" +
          '    "OfflinePushInfo": {\n' +
          '        "PushFlag": 0,\n' +
          '        "Desc": "' +
          initData["msgDesc"] +
          '",\n' +
          '        "Ext": "' +
          initData["msgContent"] +
          '",\n' +
          '        "AndroidInfo": {\n' +
          '            "Sound": "android.mp3"\n' +
          "        },\n" +
          '        "ApnsInfo": {\n' +
          '            "Sound": "apns.mp3",\n' +
          '            "BadgeMode": 1, \n' +
          '            "Title":"apns title",\n' +
          '            "SubTitle":"apns subtitle", \n' +
          '            "Image":"www.image.com" \n' +
          "        }\n" +
          "    }\n" +
          "}";
        var params = {
          token: loginUser.token,
          data: requestJson,
        };
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["quantitySendMsg"]["method"],
            url: apiMap["quantitySendMsg"]["url"],
            data: qs.stringify(params, { encode: false }),
          })
          .then(function(response) {
            _this.$store.dispatch("deleteCopyTreeApply", _this.apply.id);
            // if (response.data.result.ActionStatus == "OK") {
            //   console.log("复制家谱通知，发送成功！");
            // } else {
            //   console.log("复制家谱通知，发送失败！");
            // }
          });
      }
    },
    initTreeWithD3(treeData) {
      let _this = this;
      let target = `#${_this.treeContainerId}`;
      dTree.init(treeData, {
        target: target,
        debug: true,
        hideMarriageNodes: true,
        marriageNodeSize: 5,
        height: 480,
        width: 864,
        callbacks: {
          nodeClick: function(name, userId) {
            // alert('左击: ' + name);
            _this.initPersonClick(userId);
          },
          // nodeRightClick: function(name, extra) {
          // 	alert('右击: ' + name);
          // },
          textRenderer: function(name, userId, extra, textClass) {
            if (extra && extra.nickname)
              name = name + " (" + extra.nickname + ")";
            return (
              "<p align='center' class='" + textClass + "'>" + name + "</p>"
            );
          },
          marriageClick: function(extra, id) {
            alert("Clicked marriage node" + id);
          },
          marriageRightClick: function(extra, id) {
            alert("Right-clicked marriage node" + id);
          },
        },
        stopNode: _this.stopNode,
      });
      _this.ancestorMember = _.sortBy(_this.ancestorMember, "generation");
    },
    initTreeData(data, generation) {
      let _this = this;
      var userKey = data.userId;
      var userName = "";
      if (data.userName) {
        userName = data.userName == "null" ? "?" : data.userName;
      } else {
        userName = "?";
      }
      if (data.sex == "1" && data.status != 1) {
        var userItem = {
          userId: data.userId,
          userName: userName,
          generation: generation,
        };
        _this.ancestorMember.push(userItem);
      }
      _this.personMap[userKey] = {
        userId: userKey,
        userName: data.userName,
        sex: data.sex,
        mate: false,
        status: data.status,
      };

      var userSpouse = [];

      for (var p = 0; p < data.partners.length; p++) {
        var spouseId = data.partners[p].userId;
        var status = data.partners[p].status;
        var spouseName = "";
        if (data.partners[p].userName) {
          spouseName =
            data.partners[p].userName == "null"
              ? "?"
              : data.partners[p].userName;
        } else {
          spouseName = "?";
        }
        var curMate = {
          userId: data.partners[p].userId,
          userName: spouseName,
        };
        userSpouse.push(curMate);

        _this.personMap[spouseId] = {
          userId: spouseId,
          userName: data.partners[p].userName,
          sex: data.partners[p].sex,
          mate: true,
          status: data.partners[p].status,
        };
      }

      if (data.sex == "1") {
        _this.ancestorMate[data.userId] = userSpouse;
      }

      generation++;
      if (data.partnerPublicChildren.length !== 0) {
        for (var i = 0; i < data.partnerPublicChildren.length; i++) {
          var sureChildMother = data.partners[i].userId;
          var orderedChildren = data.partnerPublicChildren[i];
          for (var j = 0; j < orderedChildren.length; j++) {
            if (orderedChildren[j]) {
              if (orderedChildren[j].userId == _this.stopNode) {
                //对方及以下不显示
                return false;
              }
              _this.initTreeData(orderedChildren[j], generation);
            }
          }
        }
      }
    },
    initPersonClick(userId) {
      let userBrief = this.personMap[userId];
      if (userBrief) {
        if (userBrief.sex == 1) {
          if (userBrief.status != 1) {
            this.copyRelationForm.husband = userId;
            this.selectHusbandChange(userId);
          } else {
            this.$message({
              message: "这个亲人资料没有完善，不能选择噢",
            });
          }
        } else {
          this.$message({
            message: "请选择男性家谱成员",
          });
        }
      }
    },
    getMyProfile(okCBK) {
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["getProfile"]["method"],
        url: apiMap["getProfile"]["url"],
        data: `token=${loginUser.token}`,
      })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            okCBK(response.data.result.data);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.copy-cell-wrapper {
  width: 650px;
  background-color: #fff;
  border-bottom: 1px solid #f6f7f8;
}

.flex {
  display: flex;
  flex-flow: row nowrap;
}

.justify-c_space-b {
  justify-content: space-between;
}

.relative {
  position: relative;
}

.copy-cell-title {
  padding: 5px 15px 5px 0;
}

.copy-cell-title .list-left {
  margin: 0 10px;
  display: flex;
  align-items: center;
}

.list-left .avatar-box {
  position: relative;
  width: 50px;
  height: 50px;
}

/* .cell-wrapper .copy-cell-title {
    height: 60px;
} */

.user-wrapper .name {
  display: inline-block;
  max-width: 300px;
  margin: 0;
  vertical-align: top;
  font-size: 16px;
}

.user-wrapper .male {
  margin-left: 5px;
  color: #0071ff;
}

.user-wrapper .female {
  margin-left: 5px;
  color: #ff4081;
}

.content-top .time {
  color: #51555e;
  vertical-align: top;
}

.copy-cell-title .list-right {
  flex: auto;
}

.list-right .content-top {
  line-height: 20px;
}

.list-right .copy-content-bottom {
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}

.list-right .remove-session-btn {
  display: none;
  position: absolute;
  top: 28px;
  right: 14px;
  cursor: pointer;
  color: #409eff;
}

.copy-cell-wrapper:hover .remove-session-btn {
  display: inline-block;
}

.remove-session-btn:hover {
  color: #ff0000;
}

.copy-content-bottom .lastmsg {
  line-height: 20px;
}

.copy-content-bottom .respond-menu {
  display: none;
}

.respond-menu span {
  padding: 0 4px;
  color: #666666;
  cursor: pointer;
}

.respond-menu .agree {
  margin-right: 18px;
}

.respond-menu .agree:hover {
  color: #33cc33;
}

.respond-menu .decline:hover {
  color: #ff0000;
}

.copy-cell-title:hover .respond-menu {
  display: block;
}

/* 家谱样式 */
.copy-tree-wrapper {
  /* height: 480px; */
  padding: 0 4px;
  /* overflow: auto; */
  /* background-color: #f5f5f5; */
}

.copy-tree-container {
  /* width: 832px; */
  position: relative;
  text-align: center;
  box-sizing: border-box;
  /* overflow: auto; */
}

#canvasForClanTree {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.copy-tree-container .child-box {
  width: 832px;
  position: relative;
  height: 32px;
  padding: 30px 0;
  margin: 0 auto;
  white-space: nowrap;
  z-index: 3;
}

.copy-tree-container div a {
  display: inline-block;
  width: 80px;
  height: 30px;
  margin: 0 10px;
  font-size: 14px;
  border: 1px solid #000000;
  border-radius: 5px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
  color: #333333;
}

.copy-form-wrap {
  margin-top: 23px;
  padding-left: 18px;
}

.linage {
  fill: none;
  stroke: #000;
}
.marriage {
  fill: none;
  stroke: black;
}
.marriageNode {
  background-color: black;
  border-radius: 50%;
}
.man {
  line-height: 21px;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  border-radius: 4px;
}
.woman {
  line-height: 21px;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  border-radius: 4px;
}

svg.tree-svg {
  border-style: solid;
  border-width: 1px;
  border-color: #cccccc;
}
</style>
